import { useEffect, useState } from "react";
import { useSession } from "../state/SessionProvider";
import * as logolager from "../state/logolager";

/**
 * Merket i toppstripa — eller produksjonens logo, naar den finnes.
 *
 * ========  FRA DISK, IKKE FRA NETT  ========
 *
 * Appen brukes uten dekning, og en signert lenke varer en time. Fila er
 * hentet ned én gang og ligger i `state/logolager.ts`; her leses den
 * derfra. Er den ikke hentet ennaa — foerste oppstart uten nett — staar
 * Infoflyt-merket, og det er en riktig tilstand, ikke en feil.
 *
 * ========  ET BILDE, IKKE EN MASKE  ========
 *
 * Infoflyt-merket tegnes med `--mark-color`, saa det foelger paletten og
 * virker i blackout. En kundes logo kan ikke det: den har sine egne
 * farger, og i en maske ville den blitt en ensfarget flekk.
 *
 * I BLACKOUT STAAR MERKET. Blackout er natt paa sett, og en lys logo i
 * full farge er nettopp det skjermen ikke skal gjoere da.
 */
export function Merke(): JSX.Element {
  /* Leses her og ikke sendt inn, som `kanJamme` i toppstripa: App.tsx har
     ingen annen bruk for den, og en prop til gjennom stripa for ett svar
     er stoey. */
  const { production, blackout } = useSession();
  const sti = production.logoSti ?? null;
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    let levende = true;
    let gammel: string | null = null;
    setUrl(null);
    if (sti === null || sti === "" || blackout) return;
    void (async () => {
      const u = await logolager.lenke(sti);
      if (!levende) { if (u !== null) URL.revokeObjectURL(u); return; }
      gammel = u;
      setUrl(u);
    })();
    /* Blob-URL-en slippes naar flata rives. Uten dette holder fana paa
       fila til den lukkes. */
    return () => {
      levende = false;
      if (gammel !== null) URL.revokeObjectURL(gammel);
    };
  }, [sti, blackout]);

  if (url === null) return <span className="mark" aria-hidden="true" />;
  return <img className="mark mark--logo" src={url} alt="" />;
}
